"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
// external
const React = require("react");
// local
const Button_1 = require("../Button");
const Icon_1 = require("../Icon");
// css
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "iconButton");
/**
 * Component to render a button with a single icon and nothing else
 * Still has full button functionality
 * We do this because creating the icon component as a child of a button
 * looks like shit
 */
const IconButton = props => {
    // we need to pull out name just for the icon and size to keep it
    // consistent between the button and icon
    // we also check the variant because we cannot have text icon buttons
    // pull out isBlock so it's never used as you can't have a full width
    // icon button
    // the rest of the props are for the button
    const { name, size, isBlock } = props, buttonProps = __rest(props, ["name", "size", "isBlock"]);
    return (React.createElement("div", { className: css("", `-size-${size}`) },
        React.createElement(Button_1.Button, Object.assign({}, buttonProps, { size: size, className: css("btn") }),
            React.createElement(Icon_1.Icon, { name: name, size: size, className: css("icon") }))));
};
exports.IconButton = IconButton;
//# sourceMappingURL=index.js.map